module.exports = __webpack_public_path__ + "static/media/serena-icon.e9d2d017.png";